const GET_SSN_DETAILS: string = 'GET_SSN_DETAILS';

export const ADD_MEMBER_ACTION_TYPES = {
    GET_SSN_DETAILS,
};
